<div>
  <div class="modal-header">{{'dso-selector.'+ action + '.' + objectType.toString().toLowerCase() + '.head' | translate}}
    <button type="button" class="btn-close" (click)="close()" aria-label="Close">
    </button>
  </div>
  <div class="modal-body">
    <span *ngIf="header" class="h5 px-2">{{header | translate}}</span>
    <ds-authorized-collection-selector [currentDSOId]="dsoRD?.payload.uuid"
      [types]="selectorTypes"
      searchHref="findAdminAuthorized"
      (onSelect)="selectObject($event)"></ds-authorized-collection-selector>
  </div>
</div>
